<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    id="OffcanvasForm"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <div class="bg-body-secondary border offcanvas-header py-2">
      {{ type === 'CREATE'? $t('Create Adjustment'): $t('Edit Adjustment')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom mb-3 px-3 py-2">
        <i class="fa-solid fa-circle-info me-2" />
        {{ $t('Adjustment Information') }}
      </div>
      <div class="px-3">
        <div class="row g-3 py-2">
          <div class="col-md-3">
            <label
              for="transaction_date"
              class="form-label"
            >
              {{ $t('_Adjustment.Transaction Date') }}
              <span class="text-danger">*</span>
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="transaction_date"
                type="date"
                v-model.trim="v$.form.transaction_date.$model"
                class="form-control"
                :class="v$.form.transaction_date.$error? 'is-invalid': ''"
                :placeholder="$t('Enter transaction date') + '...'"
                :disabled="type === 'EDIT' && state !== 'draft'"
              >
              <div v-for="error of v$.form.transaction_date.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="branch" class="form-label">
              {{ $t('Branch') }}
              <span class="text-danger">*</span>
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <select2
                style="width: 100%;"
                v-model="v$.form.branch_id.$model"
                :options="select2Branchs.options"
                :settings="select2Branchs.setting"
                :placeholder="$t('Select Branch') + '...'"
                :disabled="type === 'EDIT' && state !== 'draft'"
              />
              <div v-for="error of v$.form.branch_id.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="stock_adjustment_reason_id" class="form-label d-flex align-items-center gap-2">
              <span>{{ $t('Reason') }} <span class="text-danger">*</span></span>
              <span v-if="directionHint" class="small" :class="directionHint.cls">
                <i :class="directionHint.icon" class="me-1"></i>{{ directionHint.text }}
              </span>
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <select2
                style="width: 100%;"
                v-model="v$.form.stock_adjustment_reason_id.$model"
                :options="select2Reasons.options"
                :settings="select2Reasons.setting"
                :placeholder="$t('Select Reason') + '...'"
                :disabled="type === 'EDIT' && state !== 'draft'"
              />
              <div v-for="error of v$.form.stock_adjustment_reason_id.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-floating">
              <textarea
                class="form-control"
                id="note"
                style=" font-size: 14px;"
                v-model.trim="v$.form.note.$model"
              />
              <label for="note">
                {{ $t('note') }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="border-bottom mb-3 px-3 py-2">
        <i class="fa-solid fa-basket-shopping me-2" />
        {{ $t('Items') }}
      </div>
      <div class="px-3">
        <div class="row g-3 py-2">
            <!-- v-if="form.items.length > 0" -->
          <div
            class="col-md-12 overflow-x-auto"
          >
            <table
              class="border table table-sm table-hover"
            >
              <thead
                class="table-light"
              >
                <tr>
                  <th
                    scope="col"
                    class="text-end"
                    style="min-width: 25px;"
                  >
                    #
                  </th>
                  <th
                    scope="col"
                    style="min-width: 200px;"
                  >
                    {{ $t('Inventory') }}
                  </th>
                  <th
                    scope="col"
                    style="min-width: 200px;"
                  >
                    {{ $t('Lot No.') }}
                  </th>
                  <th
                    scope="col"
                    class="text-end"
                    style="min-width: 150px;"
                  >
                    {{ $t('Current Quantity') }}
                  </th>
                  <th
                    scope="col"
                    class="text-end"
                    style="min-width: 150px;"
                  >
                    {{ $t('Adjustment Quantity') + ' (+/-)' }}
                  </th>
                  <th
                    scope="col"
                    style="min-width: 100px;"
                  >
                    {{ $t('Unit') }}
                  </th>
                  <th
                    scope="col"
                    style="min-width: 200px;"
                  >
                    {{ $t('_Adjustment.Optional') }}
                  </th>
                  <th
                    scope="col"
                    style="min-width: 20px;"
                  />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in form.items"
                  :key="item.inventory_id + '-' + item.inventory_lot_id"
                >
                  <item-form
                    :index="index"
                    :item="item"
                  />
                </tr>
                <tr
                  v-if="form.items.length == 0"
                >
                  <td
                    colspan="8"
                    class="text-center"
                  >
                    {{ $t('No Available Data') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="col-md-12 mt-0"
            v-if="type === 'CREATE' || state == 'draft'"
          >
            <ladda
              text="Add Items"
              :btn-class="'btn btn-primary btn-block '"
              icon="<i class='fa-solid fa-plus' /i>"
              :disabled="!selectedReasonType"
              @click="() => { if (selectedReasonType) showModalAdditem = true; }"
            />
            <small v-if="!selectedReasonType" class="text-muted ms-2">
              <i class="fa-solid fa-circle-info me-1"></i>{{ $t('Please select a reason before adding items') }}
            </small>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading"
    >
      <ladda
        text="Save"
        v-if="type === 'CREATE'"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleCreate"
      />
      <ladda
        text="Save"
        v-if="type === 'EDIT'"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleEdit"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
  <modal-add-item
    v-if="showModalAdditem"
  />
</template>

<script lang="js">
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import { StockAdjustments } from '@/services/endpoint/stock-adjustments.service';
import Select2 from 'vue3-select2-component';
import moment from "moment";
import signature  from '@/services/signature';
import ItemForm from './ItemForm.vue';
import numeral from 'numeral';
import ModalAddItem from './ModalAddItem.vue';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.form)
  },
  props: {
    type: {
      type: String,
      default: 'CREATE'
    },
    id: {
      type: Number,
      default: 0
    },
  },
  data() {
    let vm = this;
    return {
      showModalAdditem: false,
      selectInventory: [],
      listItems: [],
      loading: true,
      hasPermission: false,
      loadingSave: false,
      reasonsList: [],
      select2Branchs: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      select2Reasons: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      form: {
        transaction_date: moment(Date.now()).format('YYYY-MM-DD'),
        branch_id: 1,
        stock_adjustment_reason_id: '',
        note: '',
        items: [],
      },
      state: 'draft'
    }
  },
  components: {
    PlaceholderContent,
    AccessDenied,
    Ladda,
    Select2,
    ItemForm,
    ModalAddItem
  },
  methods: {
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    async deleteItem(index) {
      this.form.items.splice(index, 1);
    },
    async getCreateData() {
      await StockAdjustments.getCreate().then(res => {
        let vm = this;
        this.select2Branchs.options = res.data.data.branches.map(function(item) {
          return {
            id: item.id,
            text: vm.$t(item.name)
          }
        });
        this.reasonsList = res.data.data.reasons || [];
        this.select2Reasons.options = this.reasonsList.map(function(item) {
          return {
            id: item.id,
            text: vm.$t(item.name)
          }
        });
        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    async getUpdateData() {
      await StockAdjustments.getUpdate(this.id).then(res => {
        let vm = this;
        this.select2Branchs.options = res.data.filter.branches.map(function(item) {
          return {
            id: item.id,
            text: vm.$t(item.name)
          }
        });
        this.reasonsList = res.data.filter.reasons || [];
        this.select2Reasons.options = this.reasonsList.map(function(item) {
          return {
            id: item.id,
            text: vm.$t(item.name)
          }
        });
        this.state = res.data.data.status;
        this.form = {
          transaction_date: moment(res.data.data.transaction_date).format('YYYY-MM-DD'),
          branch_id: res.data.data.branch_id,
          stock_adjustment_reason_id: res.data.data.stock_adjustment_reason_id,
          note: res.data.data.note,
          items: res.data.data.items.map(function(item) {
            return {
              id: item.id,
              inventory_id: item.inventory_id,
              inventory_lot_id: item.inventory_lot_id,
              name: item.name,
              cost: item.cost,
              lot_number: item.lot_number,
              unit_id: item.unit_id,
              unit_name: item.unit_name,
              remaining_quantity: item.remaining_quantity,
              quantity: item.quantity,
              conversion_factor: item.conversion_factor,
              total_cost: item.total_cost,
              reason_detail: item.reason_detail
            }
          }),
          note: res.data.data.note,
        };
        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    setParamsBeforeSendCreate() {
      let params = _.cloneDeep(this.form);
      params.items.forEach(item => {
        item.quantity = item.quantity * item.conversion_factor;
        item.cost = item.cost / item.conversion_factor;
      });
      return $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
      });
    },
    setParamsBeforeSendUpdate() {
      let params = _.cloneDeep(this.form);
      params.items.forEach(item => {
        item.quantity = item.quantity * item.conversion_factor;
        item.cost = item.cost / item.conversion_factor;
      });
      return $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
      });
    },
    async handleEdit() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await StockAdjustments.update(this.id, this.setParamsBeforeSendUpdate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Update Stock Adjustment!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) {
          this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.$t(err?.response?.data?.message));
        }
        this.loadingSave = false;
      });
    },
    async handleCreate() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await StockAdjustments.create(this.setParamsBeforeSendCreate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Save Stock Adjustment!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) {
          this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.$t(err?.response?.data?.message));
        }
        this.loadingSave = false;
      });
    },
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas',async () => {
      this.loading = true;
      try {
        if (this.type === 'CREATE') await this.getCreateData();
        if (this.type === 'EDIT') await this.getUpdateData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$parent.offcanvasFroms.open = false;
    });
    // this.select2Suppliers.setting.dropdownParent = this.$refs.offcanvas;
  },
  computed: {
    selectedReason() {
      const id = this.form.stock_adjustment_reason_id;
      if (id === '' || id === null || id === undefined) return null;
      return this.reasonsList.find(r => String(r.id) === String(id)) || null;
    },
    selectedReasonType() {
      return this.selectedReason?.type || null;
    },
    directionHint() {
      if (this.selectedReasonType === 'decrease') return { text: this.$t('Decrease stock only'), cls: 'text-danger',  icon: 'fa-solid fa-arrow-down' };
      if (this.selectedReasonType === 'increase') return { text: this.$t('Increase stock only'), cls: 'text-success', icon: 'fa-solid fa-arrow-up' };
      if (this.selectedReasonType === 'both')     return { text: this.$t('Both directions'),     cls: 'text-primary', icon: 'fa-solid fa-arrows-up-down' };
      return null;
    },
  },
  watch: {
    selectedReasonType(newType, oldType) {
      if (newType === oldType) return;
      if (!newType || !this.form.items.length) return;
      // Auto-remove items whose direction no longer matches the new reason type.
      // 'decrease' → only items with inventory_lot_id (deduct from existing lot) allowed
      // 'increase' → only items without inventory_lot_id (create new lot) allowed
      // 'both'     → both allowed; nothing to remove
      const before = this.form.items.length;
      if (newType === 'decrease') {
        this.form.items = this.form.items.filter(i => i.inventory_lot_id);
      } else if (newType === 'increase') {
        this.form.items = this.form.items.filter(i => !i.inventory_lot_id);
      }
      const removed = before - this.form.items.length;
      if (removed > 0) {
        this.$toast.warning(this.$t('Removed') + ' ' + removed + ' ' + this.$t("item(s) that don't match the new reason direction"));
      }
    },
  },
}
</script>
